const initialState = {
    countries: null,
    regions: null,
    cities: null,
}

export default function location(state = initialState, action) {
    switch (action.type) {
        case 'SIGN_OUT':
            return initialState

        case 'LOAD_COUNTRIES_SUCCESS':
            return {
                ...state,
                countries: action.data,
            }

        case 'LOAD_COUNTRIES_ERROR':
            return {
                ...state,
                countries: null,
            }

        case 'LOAD_REGIONS_SUCCESS':
            return {
                ...state,
                regions: action.data,
            }

        case 'LOAD_REGIONS_ERROR':
            return {
                ...state,
                regions: null,
            }

        case 'LOAD_CITIES_SUCCESS':
            return {
                ...state,
                cities: action.data,
            }

        case 'LOAD_CITIES_ERROR':
            return {
                ...state,
                cities: null,
            }

        case 'CLEAR_CITIES':
            return {
                ...state,
                cities: null,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/location.js